
import { TextField, TextFieldProps } from "@mui/material";
import { useField } from "@unform/core"
import React, { useCallback, useEffect, useRef, useState } from "react";
import { IMaskInput } from 'react-imask';
import { maskCNPJEvent, maskCPFEvent, UtilidadeService } from "../services/api/utilidades/UtilidadesService";


interface CustomProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
}

const TextMaskCustom = React.forwardRef<HTMLElement, CustomProps>(
    function TextMaskCustom(props: any, ref: any) {
        const { onChange, ...other } = props;
        return (
            <IMaskInput
                {...other}
                mask="000.000.000-00"
                definitions={{
                    '#': /[1-9]/,
                }}
                inputRef={ref}
                onAccept={(value: any) => onChange({ target: { name: props.name, value } })}
                overwrite
            />
        );
    },
);

interface State {
    textmask: string;
    numberformat: string;
}

type TVTextFieldProps = TextFieldProps & {
    prefix?: string;
    name: string;
    typeMask?: string;
    maxLength?: number;
}

export const VTextMaskCPF: React.FC<TVTextFieldProps> = ({ name, typeMask, maxLength, ...rest }) => {
    const inputRef = useRef(null);
    const { fieldName, registerField, defaultValue, error, clearError } = useField(name);
    const [value, setValue] = useState(defaultValue || "");

    useEffect(() => {


        registerField({
            name: fieldName,
            ref: inputRef,
            getValue: () => value,
            setValue: (_, newValue) => {
                setValue(newValue);
            },
        });

    }, [registerField, fieldName, value])

    const handleKeyUp = useCallback((e: any) => {
        let value = e.target.value;
        setValue(Number(value));
    }, []);


    return (
        <TextField
            ref={inputRef}
            defaultValue={defaultValue}
            {...rest}
            error={!!error}
            helperText={error}
            type="text"
            value={value}
            size={"small"}
            onChange={(e: any) => {  e.target.value.length > 14 ? 
                setValue(maskCNPJEvent(e)) : setValue(maskCPFEvent(e)); rest.onChange?.(e); }}
            
            slotProps={{
                // input: {
                //     inputComponent: TextMaskCustom as any,
                //   },
                htmlInput: {                   
                    style: { fontSize: UtilidadeService.isMobile() ? 14 : 16 },
                },
                inputLabel: {
                    style: {
                        fontSize: UtilidadeService.isMobile() ? 14 : 16
                    }
                }
            }}


        />
    );
};

